import React from 'react';
import { Plot, PlotArea } from '../plot';
import { XAxis, YAxis } from '../axes';
const Chart = ({ innerSize, scatterData, lineData, domain, plotProps, plotAreaProps, xAxisProps, yAxisProps, marginFraction, children }, ref) => {
    const fraction = marginFraction && marginFraction > 0 && marginFraction < 1 ? marginFraction : 0.2;
    const axisMarginSize = Math.floor(Math.min(innerSize.width) * fraction);
    const paddingMarginSize = Math.floor(Math.min(innerSize.width) * fraction / 2);
    plotProps = plotProps || {};
    plotAreaProps = plotAreaProps || {};
    xAxisProps = xAxisProps || {};
    yAxisProps = yAxisProps || {};
    return (React.createElement(Plot, Object.assign({ innerSize: innerSize }, plotProps, { ref: ref }),
        React.createElement("g", { transform: `translate(0,${paddingMarginSize})` },
            React.createElement(YAxis, Object.assign({ dimensions: { width: axisMarginSize * 0.9, height: innerSize.height - axisMarginSize - paddingMarginSize }, domain: domain.y }, yAxisProps)),
            React.createElement("g", { transform: `translate(${axisMarginSize},${innerSize.height - axisMarginSize * 0.9 - paddingMarginSize})` },
                React.createElement(XAxis, Object.assign({ dimensions: { width: innerSize.width - axisMarginSize - paddingMarginSize, height: axisMarginSize * 0.9 }, domain: domain.x }, xAxisProps))),
            React.createElement(PlotArea, Object.assign({ transform: `translate(${axisMarginSize},0)`, dimensions: {
                    width: innerSize.width - axisMarginSize - paddingMarginSize,
                    height: innerSize.height - axisMarginSize - paddingMarginSize
                }, domain: domain, scatterData: scatterData, lineData: lineData }, plotAreaProps), children))));
};
export default React.forwardRef(Chart);
